import * as React from "react";

function SvgClose(props) {
  return <svg width={16} height={16} viewBox="0 0 16 16" {...props}><path d="M1.1 1.2l13.7 13.6m-13.7 0L14.8 1.2" fill="none" stroke="currentColor" strokeLinecap="square" opacity={0.9} /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/close_64d2d7.svg";
export { SvgClose as ReactComponent };